<script setup>
import { computed } from "vue";
import SettingsField from "./SettingsField.vue";
import { useCompanySettings } from "./useCompanySettings";

const { form } = useCompanySettings();
const hasBank = computed(() => !!(form.BankName || form.AccountNo || form.IFSCCode));
const maskedAccount = computed(() => {
  const value = String(form.AccountNo || "");
  return value.length > 4 ? `•••• ${value.slice(-4)}` : value;
});
</script>

<template>
  <div class="cs-panel">
    <section class="cs-group">
      <header class="cs-group-head">
        <h5>Bank account</h5>
        <p>Printed on invoices so customers know where to pay. Leave empty to hide it.</p>
      </header>
      <div class="row g-3">
        <div class="col-md-6">
          <SettingsField field="BankName" placeholder="e.g. State Bank of India" maxlength="100" />
        </div>
        <div class="col-md-6">
          <SettingsField field="AccountNo" placeholder="e.g. 123456789012" maxlength="18" inputmode="numeric" />
        </div>
        <div class="col-md-6">
          <SettingsField field="IFSCCode" label="IFSC code" placeholder="SBIN0001234" maxlength="11" uppercase hint="11 characters, printed on your cheque book." />
        </div>
      </div>
    </section>

    <section class="cs-group">
      <header class="cs-group-head">
        <h5>UPI</h5>
        <p>Customers can pay you by scanning or typing this UPI ID.</p>
      </header>
      <div class="row g-3">
        <div class="col-md-6">
          <SettingsField field="UPIId" label="UPI ID" placeholder="yourshop@okaxis" maxlength="100" />
        </div>
      </div>
    </section>

    <div v-if="hasBank || form.UPIId" class="cs-preview-card">
      <div class="cs-preview-title">On your invoice</div>
      <div v-if="hasBank">
        <strong>{{ form.BankName || "Bank" }}</strong>
        <span v-if="form.AccountNo"> · A/c {{ maskedAccount }}</span>
        <span v-if="form.IFSCCode"> · IFSC {{ form.IFSCCode }}</span>
      </div>
      <div v-if="form.UPIId">UPI: {{ form.UPIId }}</div>
    </div>
  </div>
</template>
